import { journalRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

// 투자 일지(매매일지) — 개인전용 MVP, 전 경로 로그인 필수 (TRAD-1855/1856)
export const journalRoute: RouteObject[] = [
  {
    path: journalRoutePaths.list.path,
    async lazy() {
      const Page = await import('@/pages/journal/JournalListPage');
      return { Component: Page.default };
    },
  },
  {
    path: journalRoutePaths.new.path,
    async lazy() {
      const Page = await import('@/pages/journal/JournalComposerPage');
      return { Component: Page.default };
    },
  },
  {
    path: journalRoutePaths.weeklyReport.path,
    async lazy() {
      const Page = await import('@/pages/journal/JournalWeeklyReportPage');
      return { Component: Page.default };
    },
  },
  {
    path: journalRoutePaths.edit.path,
    async lazy() {
      const Page = await import('@/pages/journal/JournalComposerPage');
      return { Component: Page.default };
    },
  },
  {
    path: journalRoutePaths.detail.path,
    async lazy() {
      const Page = await import('@/pages/journal/JournalDetailPage');
      return { Component: Page.default };
    },
  },
];
